import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { parseLocalDate } from '../services/utils/date-utils';

/**ToDo Documentazione */
@Pipe({
  name: 'localizedDate',
  pure: false // altrimenti non ricarica la traduzione al cambio di lingua
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(public translateService: TranslateService){}

  public transform(value: string, ...args: unknown[]): string {
    // value = data in stringa
    // args[0]  = format
    // parseLocalDate evita la conversione di fuso orario: i componenti della
    // data restano esattamente quelli inviati dal backend (es. Las Vegas)
    const asDate: Date = parseLocalDate(value);
    const format = `${args[0]}`;

    return formatDate(asDate, format, this.translateService.currentLang);
  }

}
